import React from 'react';
import { Button } from '@/components/ui/button';

/**
 * Pagination component for dashboard tables
 * Used by ExportsDashboard, ShipmentDashboard, and other tables
 */
export default function Pagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  itemLabel = 'items',
  loading = false,
  suffix = '' // Optional suffix like "(filtered)"
}) {
  const startItem = totalItems > 0 ? ((currentPage - 1) * pageSize) + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, totalItems);
  
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-3 border-t border-slate-800 gap-4" data-testid="pagination">
      <div className="text-sm text-slate-400">
        {totalItems > 0 
          ? `Showing ${startItem}-${endItem} of ${totalItems} ${itemLabel}`
          : `No ${itemLabel} found`
        }
        {suffix && ` ${suffix}`}
      </div>
      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1 || loading}
            className="border-slate-700 text-slate-300 hover:bg-slate-800 disabled:opacity-50"
          >
            First
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1 || loading}
            className="border-slate-700 text-slate-300 hover:bg-slate-800 disabled:opacity-50"
          >
            Prev
          </Button>
          <span className="text-sm text-slate-400 px-2">
            Page {currentPage} of {totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages || loading}
            className="border-slate-700 text-slate-300 hover:bg-slate-800 disabled:opacity-50"
          >
            Next
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages || loading}
            className="border-slate-700 text-slate-300 hover:bg-slate-800 disabled:opacity-50"
          >
            Last
          </Button>
        </div>
      )}
    </div>
  );
}
